import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MessengerIcon from '@/components/icons/MessengerIcon';

const CHANNEL_ICONS: Record<string, typeof MailOutlineRoundedIcon> = { gmail: MailOutlineRoundedIcon, whatsapp: WhatsAppIcon, messenger: MessengerIcon };

export function channelIcon(key: string) {
  return CHANNEL_ICONS[key] ?? InboxOutlinedIcon;
}
